// Feriados oficiales de Costa Rica
// Referencia: Código de Trabajo art. 148 y leyes complementarias.

const FIJOS = [
  { mes: 1,  dia: 1,  nombre: "Año Nuevo" },
  { mes: 4,  dia: 11, nombre: "Día de Juan Santamaría" },
  { mes: 5,  dia: 1,  nombre: "Día Internacional del Trabajador" },
  { mes: 7,  dia: 25, nombre: "Anexión del Partido de Nicoya" },
  { mes: 8,  dia: 2,  nombre: "Día de la Virgen de los Ángeles" },
  { mes: 8,  dia: 15, nombre: "Día de la Madre" },
  { mes: 9,  dia: 9,  nombre: "Día del Niño y la Niña" },
  { mes: 9,  dia: 15, nombre: "Día de la Independencia" },
  { mes: 12, dia: 1,  nombre: "Día de la Abolición del Ejército" },
  { mes: 12, dia: 25, nombre: "Navidad" },
];

// Jueves y Viernes Santo (Semana Santa) — cálculo precomputado por año
const SEMANA_SANTA = {
  2024: { jueves: "2024-03-28", viernes: "2024-03-29" },
  2025: { jueves: "2025-04-17", viernes: "2025-04-18" },
  2026: { jueves: "2026-04-02", viernes: "2026-04-03" },
  2027: { jueves: "2027-03-25", viernes: "2027-03-26" },
  2028: { jueves: "2028-04-13", viernes: "2028-04-14" },
  2029: { jueves: "2029-03-29", viernes: "2029-03-30" },
  2030: { jueves: "2030-04-18", viernes: "2030-04-19" },
  2031: { jueves: "2031-04-10", viernes: "2031-04-11" },
  2032: { jueves: "2032-03-25", viernes: "2032-03-26" },
};

function pad(n) { return n < 10 ? `0${n}` : String(n); }

export function getFeriadosOf(year) {
  const items = FIJOS.map(f => ({
    fecha: `${year}-${pad(f.mes)}-${pad(f.dia)}`,
    nombre: f.nombre,
  }));
  const ss = SEMANA_SANTA[year];
  if (ss) {
    items.push({ fecha: ss.jueves, nombre: "Jueves Santo" });
    items.push({ fecha: ss.viernes, nombre: "Viernes Santo" });
  }
  return items.sort((a, b) => a.fecha.localeCompare(b.fecha));
}

// Devuelve { fecha, nombre } si la fecha (YYYY-MM-DD) es feriado oficial, si no null
export function feriadoEnFecha(fechaISO) {
  if (!fechaISO || fechaISO.length < 10) return null;
  const year = parseInt(fechaISO.slice(0, 4), 10);
  const items = getFeriadosOf(year);
  return items.find(i => i.fecha === fechaISO) || null;
}
